import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import moment from 'moment'
import './RootContainer.css';

import { fetchHistory, cloneToDate, deleteHistoryItem } from '../../actions/history-actions';
import { showPreviousMonth, showNextMonth, toggleTabs } from '../../actions/ui-actions';

import BreakdownHeader from '../../components/BreakdownHeader/BreakdownHeader'
import BreakdownNav from '../../components/BreakdownNav/BreakdownNavv';
import BreakdownGraph from '../../components/BreakdownGraph/BreakdownGraph';
import BreakdownTabs from '../BreakdownTabs/BreakdownTabs';
import Dumbledore from '../../components/Dumbledore/Dumbledore';
import { penceToPounds } from '../../utils/currency';
import PercentageChange from '../../components/PercentageChange/PercentageChange'
import CloneHistoryItem from '../../components/CloneHistoryItem/CloneHistoryItem'

class RootContainer extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      tabIndex: 0,
      showCopyToDate: false,
      dateValue: '',
      fetchingHistory: false,
      fetchedHistory: false
    };
    this.handlePreviousClick = this.handlePreviousClick.bind(this)
    this.handleNextClick = this.handleNextClick.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleOnDateChange = this.handleOnDateChange.bind(this)
    this.handleDeleteHistoryItem = this.handleDeleteHistoryItem.bind(this)
    this.handleToggleCopyToDate = this.handleToggleCopyToDate.bind(this)
  }

  componentDidMount() {
    const { dispatch, historyItem } = this.props
    dispatch(fetchHistory())
    this.setState({ fetchingHistory: true })
  }

  handleToggleCopyToDate() {
    this.setState({ showCopyToDate: !this.state.showCopyToDate })
  }

  handleDeleteHistoryItem() {
    const { dispatch, historyItem, currentHistoryIndex } = this.props
    dispatch(deleteHistoryItem(historyItem._id))
  }

  handleSubmit(event) {
    event.preventDefault()
    const { dispatch } = this.props
    this.handleToggleCopyToDate()

    const selectedDateString = new Date(this.state.dateValue)
    let selectedDate = {
      year: selectedDateString.getFullYear(),
      month: selectedDateString.getMonth() + 1,
      day: selectedDateString.getDate(),
    }
    dispatch(cloneToDate(selectedDate))
  }

  handleOnDateChange(event) {
    this.setState({ dateValue: event.target.value })
  }

  handlePreviousClick() {
    const { dispatch, isFirstRecordedMonth } = this.props
    if (isFirstRecordedMonth) {
      // Could do a route change here
      return
    }
    dispatch(showPreviousMonth())
  }

  handleNextClick() {
    const { dispatch, isLatestOne } = this.props
    if (isLatestOne) {
      // Could do a route change here
      return
    }
    dispatch(showNextMonth())
  }

  getBalanceTotal(assets) {
    return assets.reduce((acc, asset) => {
      return acc + asset.balance
    }, 0)
  }

  getPercentageChange(a, b) {
    if (a === 0) {
      return b / 100;
    }

    const change = ((b - a) / (a)) * 100;

    if (a < 0) {
      return change * -1;
    }

    return change;
  }

  renderSubNavigation () {
    const { history, currentHistoryIndex, isLatestOne, showDumbledore } = this.props

    if (history.length === 1) {
      return null
    }

    return (
      <div className="subheader">
      <div className="container">
        <div className="subheader__inner">
        <BreakdownNav
          currentDay={history[currentHistoryIndex].day}
          currentMonth={history[currentHistoryIndex].month}
          currentYear={history[currentHistoryIndex].year}
          handlePreviousClick={this.handlePreviousClick}
          handleNextClick={this.handleNextClick}
          hasNext={currentHistoryIndex < history.length - 1}
          hasPrevious={currentHistoryIndex > 0}
        />
        </div>
      </div>
    </div>
    )
  }

  render(props) {
    const { history, currentHistoryIndex, isLatestOne, showDumbledore } = this.props
    const isFirstRecordedMonth = currentHistoryIndex === 0

    if (showDumbledore === false && history.length === 0) {
      return null
    }

    console.log('showDumbledore && history.length === 0', showDumbledore && history.length === 0)
    if (showDumbledore && history.length === 0) {
      return <Dumbledore />
    }

    const totalBalance = history[currentHistoryIndex].balance;
    const assetsBalance = this.getBalanceTotal(history[currentHistoryIndex].assets);
    const liabilitiesBalance = this.getBalanceTotal(history[currentHistoryIndex].liabilities);
    const currentMonthDate = history[currentHistoryIndex].month
    const currentMonth = history[currentHistoryIndex]

    let totalChange = 0
    let assetsChange = 0
    let liabilitiesChange = 0
    if (!isFirstRecordedMonth) {
      const lastMonthTotalBalance = history[currentHistoryIndex - 1].balance
      const lastMonthAssetBalance = this.getBalanceTotal(history[currentHistoryIndex - 1].assets)
      const lastMonthLiabilitiesBalance = this.getBalanceTotal(history[currentHistoryIndex - 1].liabilities)
      totalChange = this.getPercentageChange(lastMonthTotalBalance, totalBalance)
      assetsChange = this.getPercentageChange(lastMonthAssetBalance, assetsBalance)
      liabilitiesChange = this.getPercentageChange(lastMonthLiabilitiesBalance, liabilitiesBalance)
    }


    const formatDate = (currentYear, currentMonth, currentDay) => {
      return moment({
        year: currentYear,
        month: currentMonth - 1,
        day: currentDay,
      }).format('LL');
    }

    let period = null
    if (currentHistoryIndex > 0) {
      period = `${formatDate(history[currentHistoryIndex - 1].year, history[currentHistoryIndex - 1].month, history[currentHistoryIndex - 1].day)} - ${formatDate(history[currentHistoryIndex].year, history[currentHistoryIndex].month, history[currentHistoryIndex].day)}`
    }

    const fmtDate = moment({
      year: history[currentHistoryIndex].year,
      month: history[currentHistoryIndex].month - 1,
      day: history[currentHistoryIndex].day,
    }).format('LL');

    return (

      <div>

        {this.renderSubNavigation()}

        <main className="main">

          <section className="summary">
            <div className="container">

              <div className="row">
                <div className="cell cell--big">
                  <div className="panel panel--total">
                    <div className="panel__inner">
                      <h2>
                        {penceToPounds(totalBalance)}
                        <PercentageChange percentage={totalChange} />
                      </h2>
                      <h4>Your Total Net Worth</h4>
                    </div>
                  </div>
                </div>
                <div className="cell">
                  <div className="panel panel--assets">
                    <div className="panel__inner">
                      <h2>
                        {penceToPounds(assetsBalance)}
                        <PercentageChange percentage={assetsChange} />
                      </h2>
                      <h4>Assets</h4>
                    </div>
                  </div>
                </div>
                <div className="cell">
                  <div className="panel panel--liabilities">
                    <div className="panel__inner">
                      <h2>
                        {penceToPounds(liabilitiesBalance * -1)}
                        <PercentageChange percentage={liabilitiesChange * -1} />
                      </h2>
                      <h4>Liabilities</h4>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </section>

          <div className="graph-wrapper">

            <div className="container">


              <div className="graph-wrapper__inner">


                <h2>
                  Your net worth over time

                  <small>
                  <span style={{ color: '#CCC' }}>Current Month: </span>
                  <span>{fmtDate}</span>
                </small>

           <CloneHistoryItem
                    showCopyToDate={this.state.showCopyToDate}
                    dateValue={this.state.dateValue}
                    handleOnDateChange={this.handleOnDateChange}
                    handleToggleCopyToDate={this.handleToggleCopyToDate}
                    handleSubmit={this.handleSubmit}
                    handleToggleCopyToDate={this.handleToggleCopyToDate}
                  />
                </h2>

                {history.length === 1 && (
                  <p>
                    Click <strong className="text-success">"Add New Month"</strong> to
               show a graph of your net worth over a given period
               (we like to do ours every month on the same day). This could be
               adding dates in the past or future dates.
             </p>
                )}

                <BreakdownGraph
                  history={history}
                  currentDay={history[currentHistoryIndex].day}
                  currentMonth={history[currentHistoryIndex].month}
                  currentYear={history[currentHistoryIndex].year}
                  handlePreviousClick={this.handlePreviousClick}
                  handleNextClick={this.handleNextClick}
                  hasNext={currentHistoryIndex < history.length - 1}
                  hasPrevious={currentHistoryIndex > 0}
                />





                {!this.state.showCopyToDate && <button className="btn btn-light" onClick={this.handleDeleteHistoryItem}>Delete Current Month</button>}



              </div>
            </div>


          </div>




          <BreakdownTabs
          tabsIndex={this.state.tabIndex}
          handleSelectTab={(tabIndex) => {
            this.setState({ tabIndex })
            this.props.dispatch(toggleTabs(tabIndex))
          }}
          assets={currentMonth.assets}
          liabilities={currentMonth.liabilities}
        />



        </main>

        <footer className="footer">
          <div className="container">
            A <a href="http://fika.studio">Fika Studio</a> Project
          </div>
        </footer>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  history: state.history.history,
  historyItem: state.history.history[state.history.currentHistoryIndex],
  currentHistoryIndex: state.history.currentHistoryIndex,
  isLatestOne: state.history.history.length - 1 === state.history.currentHistoryIndex,
  isFirstRecordedMonth: state.history.currentHistoryIndex === 0,
  fetchedHistory: state.history.fetchedHistory,
  showDumbledore: state.ui.showDumbledore
});

export default connect(mapStateToProps)(RootContainer);



// WEBPACK FOOTER //
// ./src/containers/RootContainer/RootContainer.js